<template>
  <dialog :id="dialogId" aria-labelledby="thisModalLabel">
    <h5 class="modal-title mb-2">{{ title }}</h5>
    <slot>
      Content goes here
    </slot>  
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        @click="cancel"
      >
        Cancel
      </button>
      <button type="button" class="btn btn-primary" @click="confirm">Ok</button>
    </div>     
  </dialog>
</template>

<script lang="js">
import { defineComponent, watch, ref, onMounted } from "@vue/composition-api";

export default defineComponent({
  components: {
  },
  props: {
    value: Boolean,
    title: String,
    dialogId: {
      type: String,
      default: 'thisDialog'
    }
  },
  setup(props, { emit }) {
    let modal = null
    let nextFunction = null

    const prompt = (next) => {
      modal = modal || document.getElementById(props.dialogId)
      nextFunction = next
      modal.showModal();
    }

    onMounted(() => {
      modal = document.getElementById(props.dialogId);
    })

    watch(() => props.value, () => {
      if (props.value) {
        modal.showModal();
      }
    })

    const confirm = () => {
      nextFunction()
      modal.close()
    }

    const cancel = () => {
      modal.close()
    }

    return {
        prompt,
        confirm,
        cancel
    };
  }
});
</script>